import React from 'react';

export default function Callback() {
	return (
		<div>You can close this window</div>
	)
}